import React, { useMemo } from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import querystring from 'query-string';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import FeverIconButton from 'components/common/Button/FeverIconButton';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import useClientHistory, { RESULT } from 'client/hooks/useClientHistory';
import { joinRegex } from 'client/hooks/useInitPromo/useInitPromo';
import { IS_IFRAME_MODE } from 'config/envVariable';
import { useSelector } from 'react-redux';
import { gameTypes, isPurePrizeGames } from 'config/promoGameTypes';
import { isDoNotShowCheckRecordsBtnGames } from 'config/promoGameTypesClientConfig';
import useSystemBtnStyleByTheme from 'client/hooks/useSystemBtnStyleByTheme';
import ViewResultButton from 'components/common/Button/ViewResultButton.js';

const TaskRecordHeader = ({ promoUuid, taskUuid }) => {
    const gameType = useSelector(s => s.promo.type);
    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const { currentEntryUUID } = useSelector(s => s.userEntryState);
    const history = useClientHistory();
    const themeStyle = usePromoSettingThemeStyle();
    const isJoinPage = Boolean(window.location?.pathname?.match(joinRegex));
    const promoType = useSelector(s => s.promo.type);
    const isGameReadyToPlay = useSelector(s => s.purePrizeState.isGameReadyToPlay);
    const { primaryBtnStyle } = useSystemBtnStyleByTheme(themeStyle);
    const handleRedirectToParentUrl = () => {
        const queryParams = querystring.parse(window.location.search);
        const qs = createQueryString(queryParams);
        const taskReferrerUrl = createTaskReferrerUrl(promoUuid, qs);
        redirectToUrl(taskReferrerUrl);
    };
    // [#86erauggn] 只要流程帶著指定參數，左上角都顯示返回按鈕
    const shouldBackToMultiChallengeTaskPromoBtn = promoUuid && taskUuid;

    const createQueryString = ({ test_code, test_expired }) => {
        return test_code && test_expired
            ? `?${querystring.stringify({ test_code, test_expired })}`
            : '';
    };

    const createTaskReferrerUrl = (promoUuid, queryString) => {
        return `https://${window.location.host}/r/promotions/p/${promoUuid}${queryString}`;
    };

    const redirectToUrl = url => {
        if (IS_IFRAME_MODE) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }
    };

    const shouldHideJoinPageRecordBtn = useMemo(() => {
        if (!isJoinPage) {
            return true;
        }
        if (isDoNotShowCheckRecordsBtnGames(gameType)) {
            return true;
        }
        // [#86eu5baj1] 純獎遊戲如果等於1筆記錄 → 檢查該記錄的UUID是否等於當前Entry的UUID - 如果相等 → 隱藏按鈕
        if (isPurePrizeGames(gameType)) {
            if (userGameResultRecords.length < 1) {
                return true;
            }
            if (userGameResultRecords.length === 1) {
                const singleRecord = userGameResultRecords[0];
                if (singleRecord.uuid === currentEntryUUID) {
                    return true;
                }
            }
            return false;
        }
        if (userGameResultRecords.length === 0) {
            return true;
        }
        if (promoType === gameTypes.RED_ENVELOPE_RAIN && isGameReadyToPlay) {
            return true;
        }
        return false;
    }, [
        isJoinPage,
        gameType,
        userGameResultRecords,
        promoType,
        isGameReadyToPlay,
        currentEntryUUID
    ]);

    function handleCheckRecord() {
        history.push(RESULT);
    }

    return (
        <div css={taskRecordHeaderContainerStyle}>
            {shouldBackToMultiChallengeTaskPromoBtn && (
                <FeverIconButton
                    variant="text"
                    text={i18n.t('label.back_to.task_card')}
                    textColor={themeStyle.buttonBgColor}
                    icon={ArrowLeftIcon}
                    iconVariant="default"
                    iconPosition="start"
                    iconSize={24}
                    buttonStyle={customButtonStyle(themeStyle.buttonBgColor)}
                    onClick={handleRedirectToParentUrl}
                    disableTouchRipple={true}
                />
            )}
            {!shouldHideJoinPageRecordBtn && (
                <div css={joinPageRecordBtnContainerStyle}>
                    <ViewResultButton onClick={handleCheckRecord} btnStyle={primaryBtnStyle} />
                    {/* [86eu5mhmg] 因為這個問題所以先隱藏 */}
                    {/* <ViewPrizeListButton
                        btnStyle={viewPrizeListBtnStyle}
                        onToPrize={handleToPrize}
                        isLoading={isFetchingWinner}
                        ref={winnerRef}
                    /> */}
                </div>
            )}
        </div>
    );
};

export default TaskRecordHeader;

const customButtonStyle = color => css`
    background-color: transparent;
    padding: 8px;

    & .MuiBox-root {
        margin-right: 4px;

        & .MuiIconButton-root {
            padding: 0;
        }

        & .MuiSvgIcon-root {
            color: ${color};
        }
    }

    &:hover {
        background-color: transparent;
    }

    &:active {
        box-shadow: none;
    }
`;

const taskRecordHeaderContainerStyle = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const joinPageRecordBtnContainerStyle = css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px;
    margin-left: auto;
`;
